import React from 'react';
import ProductInterface from '../ProductInterface';
import MonsmryOptions from './MonsmryOptions';
import { processMonsmry } from './monsmryProcess';

export default function Monsmry() {
  return (
      <ProductInterface
          product = "monsmry"
          ProductOptions = {MonsmryOptions}
          processProduct = {processMonsmry}
      />
  )
} 